export default __webpack_public_path__ + "static/media/petBoarding.406f3bb1.jpg";